{
  "ordersInfo": {
    "status": {
      "new": "New",
      "partially_filled": "Partially Filled",
      "filled": "Filled",
      "done_for_day": "Done for the Day",
      "canceled": "Canceled",
      "expired": "Expired",
      "replaced": "Replaced",
      "pending_cancel": "Pending Cancellation",
      "pending_replace": "Pending Replacement",
      "accepted": "In Processing",
      "pending_new": "Pending Creation",
      "rejected": "Rejected",
      "calculated": "Calculated",
      "accepted_for_bidding": "Accepted for Bidding",
      "stopped": "Stopped",
      "suspended": "Suspended",
      "held": "Held"
    },
    "orderHints": {
      "bracket": {
        "main": {
          "title": "Order A",
          "helpText": "If Order A is executed, then Orders B and C will be placed"
        },
        "secondary": [
          {
            "title": "Order B",
            "helpText": "If Order B is executed, then Order C will be cancelled"
          },
          {
            "title": "Order C",
            "helpText": "If Order C is executed, then Order B will be cancelled"
          }
        ]
      },
      "oto": {
        "main": {
          "title": "Order A",
          "helpText": "If Order A is executed, then Order B will be placed"
        },
        "secondary": [
          {
            "title": "Order B"
          }
        ]
      },
      "oco": {
        "main": {
          "title": "Order A",
          "helpText": "If Order A is executed, then Order B will be cancelled"
        },
        "secondary": [
          {
            "title": "Order B",
            "helpText": "If Order B is executed, then Order A will be cancelled"
          }
        ]
      }
    }
  }
}
